<template>
  <div class="nh-trust">
    <div class="nh-trust-loading">
      <div class="nh-spinner"></div>
      <p class="nh-trust-text">正在跳转可信身份认证...</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { getTrustUrlRe } from '@/api/common';

onMounted(async () => {
  try {
    const url = await getTrustUrlRe();
    if (url) {
      window.location.href = url.data;
    }
  } catch (e) {
    // 接口失败不做事，保持加载态
  }
});
</script>

<style lang="scss" scoped>
.nh-trust {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.nh-trust-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.nh-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f0d9d9;
  border-top-color: #bd1a2d;
  border-radius: 50%;
  animation: nh-spin 0.8s linear infinite;
}

@keyframes nh-spin {
  to {
    transform: rotate(360deg);
  }
}

.nh-trust-text {
  margin: 0;
  font-size: 16px;
  color: #666;
}
</style>
